export default __webpack_public_path__ + "static/media/referral-share@2x.d3911b6e.png";